import React from 'react';
import PropTypes from 'prop-types';
import loadScript from 'load-script';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';

//import GooglePicker from 'react-google-picker';
import { Button, Dialog, DialogTitle, DialogContent, Menu,
         MenuItem, Typography, DialogActions, List, ListItem,
         ListItemIcon, ListItemText, TextField, Snackbar, } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

import { Folder, Description, ArrowUpward } from '@material-ui/icons';
import { ClaimSet } from './CGModel';

const GOOGLE_SDK_URL = 'https://apis.google.com/js/api.js';

// The Browser API key obtained from the Google API Console.
// Replace with your own Browser API key, or your own key.
//const API_KEY = 'AIzaSyAvEgKlcy7TK3zhl2EJQz9o9Z9xEiqt1og';
const API_KEY = 'AIzaSyATi6_qe5ud1dqoxsZr0t8O_1HvuUeRMxA';

// The Client ID obtained from the Google API Console. Replace with your own Client ID.
//const CLIENT_ID = "177948272498-estaii235ag79k0q21fog4cd2e87qbo1.apps.googleusercontent.com";
const CLIENT_ID = "367498997284-kegc41cifibcgjrnip2np3428s1ll6tr.apps.googleusercontent.com";

// Replace with your own project number from console.developers.google.com.
// See "Project number" under "IAM & Admin" > "Settings"
//var appId = "177948272498";
//var appId = "177948272498";
var appId = "367498997284";

// Scope to use to access user's Drive items.
var scope = 'https://www.googleapis.com/auth/drive.file';

// Array of API discovery doc URLs for APIs used by the quickstart
var DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"];

let scriptLoadingStarted = false;

var GoogleAuth = null;
var OAuthToken = null;
var pickerApiLoaded = false;
export var userProfile = null;

function isGoogleReady() {
  return !!window.gapi;
}

function isGoogleAuthReady() {
  return !!window.gapi.auth2 && !!GoogleAuth;
}

function isSignedIn() {
  return isGoogleAuthReady() && GoogleAuth.isSignedIn.get();
}

export function signOut(workshop) {
  console.log('Disconnecting');
  userProfile = null;
  if (workshop) workshop.setGoogleUser(null);
  if (GoogleAuth.isSignedIn.get())
    GoogleAuth.signOut();
}

function initAuth() {
  if (!isGoogleReady() && !scriptLoadingStarted) {
    console.log('Loading script');
    scriptLoadingStarted = true;
    loadScript(GOOGLE_SDK_URL, loadAPI);
  }
}

function loadAPI(err) {
  if (err) {
    // FIXME:  need to do something better to handle this error
    console.log("Error loading script:", err);
    return;
  }
  console.log('API loaded');
  window.gapi.load('client:auth2', initClient);
  window.gapi.load('picker', ()=>pickerApiLoaded=true);
}

function initClient(callback) {
  console.log('Initializing Google client');
  try {
    window.gapi.client.init({
      'apiKey': API_KEY,
      'clientId': CLIENT_ID,
      'scope': scope,
      'discoveryDocs': DISCOVERY_DOCS,
    }).then(function() {
      //console.log('AI -----', GoogleAuth);
      GoogleAuth =  window.gapi.auth2.getAuthInstance();
      GoogleAuth.isSignedIn.listen(() => console.log('********************'));
      if (callback) callback();
    },
            function(error) { console.log('API init error', error); });
  }
  catch (e) { console.log('API init exception', e); }
}

function dumpUser() {
  userProfile = GoogleAuth.currentUser.get().getBasicProfile();
  console.log('USER', userProfile.getName(), userProfile.getEmail());
}

function authenticated(callback) {
  console.log('Authenticated call');
  if (!isGoogleReady() || !isGoogleAuthReady()) {
    return initClient(() => authenticated(callback));
  }
  if (isSignedIn()) {
    OAuthToken = GoogleAuth.currentUser.get().getAuthResponse(true).access_token;
    dumpUser();
    callback();
  }
  else {
    GoogleAuth
      .signIn()
      .then(result => {
        if (result) {
          console.log('Signed in', result);
          OAuthToken = GoogleAuth.currentUser.get().getAuthResponse(true).access_token;
          dumpUser();
          callback();
        }
        else
          console.log("Authentication failed", result);
      }, function(err) {console.log('Auth error', err);});
  }
}

initAuth();

// -----------------------------------------------------------------------
// Utility functions to list, load, store files to GDrive
// -----------------------------------------------------------------------

function listFiles(folder, callback) {
  console.log('Listing', folder, GoogleAuth);
  const _list = () => {
    var url = `https://www.googleapis.com/drive/v3/files?fields=files(name,id,modifiedTime,mimeType,parents)&key=${API_KEY}&`;
    //var url = `https://www.googleapis.com/drive/v3/files?fields=files(*)&key=${API_KEY}&`;
    //url += "fields=modifiedTime&q=name contains '.cws' and mimeType = 'application/json'";
    //url += "q=mimeType='application/vnd.google-apps.folder' and trashed=false";
    //url += "q=name contains '.cws' and mimeType='application/vnd.google-apps.folder' and trashed=false";
    url += `q='${folder}' in parents and trashed=false and (name contains '.cws' or mimeType='application/vnd.google-apps.folder')`;
    var accessToken = GoogleAuth.currentUser.get().getAuthResponse(true).access_token;
    fetch(url, {
      method: 'GET',
      headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
    }).then((res) => {
      console.log('RESULT', res);
      return res.json();
    }).then(function(val) {
      console.log('FETCH', val);
      if (callback) callback(val.files);
    }).catch(function(err) {
      console.log('ERROR', err);
    });
  };
  authenticated(_list);
}


// Doc is {name: str, id: str}
// Cases:
// On SaveAs, we want to use the doc parameter (will be new file if id == null)
// On Save, we want to use workshop.doc
// The metadata always comes from doc parameter, so the caller must specify the correct one

export function saveToGDrive(workshop, doc, callback) {
  const _save = () => {
    console.log('SAVING', toJS(workshop), doc);
    var file = new Blob([JSON.stringify(workshop.claimSet.dumpClaims(), null, 2)], {type: 'application/json'});
    var metadata = {name: doc.name, mimeType: 'application/json'};
    var method = 'POST';
    //var url = `https://www.googleapis.com/upload/drive/v3/files?key=${developerKey}`;
    var url = `https://www.googleapis.com/upload/drive/v3/files?key=${API_KEY}&uploadType=multipart`;
    if (doc.id) {
      metadata = {
        'name': doc.name,   // Filename at Google Drive
        'id': doc.id,
        'mimeType': 'application/json', // mimeType at Google Drive
        'parents': [doc.parentId], // Folder ID at Google Drive
      };
      method = 'PATCH';
      url = `https://www.googleapis.com/upload/drive/v3/files/${doc.id}`;
    }
    var accessToken = GoogleAuth.currentUser.get().getAuthResponse(true).access_token;
    console.log(metadata, accessToken);
    var form = new FormData();
    form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
    form.append('file', file);
    
    fetch(url, { 
      method: method,
      headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
      body: form,
    }).then((res) => {
      console.log('RESULT', res);
      return res.json();
    }).then(function(val) {
      console.log('SAVE_FETCH', val);
      callback(val);
    }).catch(function(err) {
      console.log('ERROR', err);
    });
  };
  authenticated(_save);
}

// This is a mess and I don't know why.
// Sometimes we get a multipart response, and sometimes
// we don't...
function parseResponse(text) {
  if (text.startsWith('--')) {
    var start = text.indexOf('{');
    var end = text.indexOf('}', start+1);
    const doc = JSON.parse(text.slice(start, end+1));
    start = text.indexOf('{', end);
    end = text.lastIndexOf('\n');
    end = text.lastIndexOf('\n', end-1);
    const contents = JSON.parse(text.slice(start, end));
    return {doc, contents};
  }
  return {contents: JSON.parse(text)};
}

export function loadFromGDrive(workshop, callback) {
  const _load = () => {
    console.log('LOADING', workshop.doc);
    var method = 'GET';
    //var url = `https:www.googleapis.com/upload/drive/v3/files?key=${developerKey}`;
    var url = `https://www.googleapis.com/drive/v3/files/${workshop.doc.id}?alt=media`;
    var accessToken = GoogleAuth.currentUser.get().getAuthResponse(true).access_token;
    console.log(url);
    console.log(accessToken);
    
    fetch(url, { 
      method: method,
      headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
    }).then((res) => {
      console.log('RESULT', res);
      return res.blob();
    }).then(function(blob) {
      return blob.text();
    }).then(function(text) {
      //window.foobar = text;
      console.log('FETCH', text);
      const resp = parseResponse(text);
      console.log('FETCHR', resp);
      workshop.setClaimSet(ClaimSet.claimSetFromJSON(resp.contents));
      callback(resp.doc || workshop.doc);
      //parseResponse(text)));
    }).catch(function(err) {
      console.log('ERROR', err);
    });
    
  };
  authenticated(_load);
}


// -----------------------------------------------------------------------
// UI Elements
// -----------------------------------------------------------------------

const Notice = ({open}) => {
  const [isOpen, setOpen] = React.useState(open);
  
  return (
    <Dialog open={isOpen} onClose={() => setOpen(false)} scroll='body'>
      <div style={{padding: '1.5em'}}>
        <Typography variant="h5" paragraph={true}>
          Use Google Drive?
        </Typography>
        <Typography variant="body1" display='block' paragraph={true}>
          ClaimWorkShop would like to access your personal
          Google Drive account to store your files.  Why?
        </Typography>
        <Typography variant="body1" display='block' paragraph={false}>
          The content of your claim file is your confidential information.
          You keep control of your claim files by storing them on your Google Drive.
          If you grant access, ClaimWorkShop will only be able to
          access the files that it has created, along with your public profile
          information, such as your name and email address.
        </Typography>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            color="primary" autoFocus >
            Got It
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};


export const FileMenu = observer((props) => {
  const workshop = props.workshop;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [giveNotice, setGiveNotice] = React.useState(null);
  const [showError, setShowError] = React.useState(null);
  //const [doc, setDoc] = React.useState({name: '', id: null});
  const [path, setPath] = React.useState([{id: 'root', name: 'GDrive'}]);
  const [docs, setDocs] = React.useState([]);
  const [fetching, setFetching] = React.useState(false);
  const [pickerVisible, setPickerVisible] = React.useState(false);
  const [action, setAction] = React.useState('save');
  const [warningVisible, setWarningVisible] = React.useState(false);
  
  const list = (fileId) => {
    console.log('Listing');
    setFetching(true);
    listFiles(fileId, (files) => {
      console.log('Setting docs');
      setDocs(files || []);
      workshop.setGoogleUser(userProfile);
      setFetching(false);
    });
  };
  
  const save = () => {
    setFetching(true);
    console.log('SAVING', action, workshop.doc);
    saveToGDrive(workshop, workshop.doc, (doc) => {
      workshop.setGoogleUser(userProfile);
      workshop.claimSet.setDirty(false);
      setFetching(false);
    });
  };
  
  const load = () => {
    setFetching(true);
    loadFromGDrive(workshop, (doc) => {
      workshop.setDoc(doc);
      workshop.setGoogleUser(userProfile);
      workshop.claimSet.setDirty(false);
      setFetching(false);
    });
  };

  // Makes sure that unsaved file is saved first
  const newWithWarning = () => {
    if (workshop.claimSet.dirty) {
      setAction('new');
      setWarningVisible(true);
    }
    else {
      close();
      workshop.newClaimSet();
    }
  };


  // If file selected just do it, otherwise pick
  const doSave = () => {
    if (giveNotice === null)
      setGiveNotice(true);
    else if (workshop.doc.id) {
      close();
      save();
    }
    else {
      openPicker('save');
    }
  };
  
  // Makes sure that unsaved file is saved first
  const loadWithWarning = () => {
    if (giveNotice === null) {
      setGiveNotice(true);
    }
    else if (workshop.claimSet.dirty)  {
      console.log('warning');
      setAction('load');
      setWarningVisible(true);
    }
    else {
      console.log('picking');
      openPicker('load');
    }
  };

  const close = () => {
    setAnchorEl(null);
    setPickerVisible(false);
    setWarningVisible(false);
  };

  const openPicker = (action) => {
    setAction(action);
    //if (action == 'save as')
    //  setDoc({name : '', id : null});
    list(path[0].id);
    setPickerVisible(true);
  };

  return (
    <span>
      {giveNotice && <Notice open={giveNotice}/>}
      {showError && <Snackbar open={showError}>
                     <MuiAlert severity="error" onClose={() => setShowError(null)}>
                       {showError}
                       </MuiAlert>
                    </Snackbar>}
      <Button variant="text"
              onClick={(e) => {
                setAnchorEl(e.currentTarget);
              }}>
        File
      </Button>
      <Menu anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            keepMounted
            onClose={close}
      >
        <div style={{fontWeight: 500, margin: '0.5em 0.5em 0em'}} key='filemenu_sub1'>
          GOOGLE DRIVE
        </div>
        <MenuItem disabled={fetching} onClick={doSave} >
          Save
        </MenuItem>
        <MenuItem disabled={fetching} onClick={() => openPicker('save as') }>
          Save As
        </MenuItem>
        <MenuItem disabled={fetching} onClick={loadWithWarning}>
          Load
        </MenuItem>
        <div style={{fontWeight: 500, margin: '0.5em 0.5em 0em'}} key='filemenu_sub2'>
          LOCAL
        </div>
        <MenuItem
          key='filemenu-upload'
          onClick={()=>{
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = '.cws';
            input.onchange = (e) => {
              console.log('ONCHANGE');
              const file = e.target.files[0];
              window.theFile = file;
              file.text()
                .then(text => {
                  const json = JSON.parse(text);
                  console.log('Upload received', json);
                  workshop.setClaimSet(ClaimSet.claimSetFromJSON(json));
                })
                .catch(error => {
                  console.log('Upload error', error);
                  setShowError('Error, does not look like a ClaimWorkShop file');
                });
            };
            input.click();
            close();
          }}>
          Upload
        </MenuItem>
        <MenuItem
          key='filemenu_download'
          onClick={()=>{
            const blob = new Blob([JSON.stringify(workshop.claimSet.dumpClaims(), null, 2)],
                                  {type: 'application/json;charset=utf8;'});
            const element = document.createElement('a');
            element.setAttribute("href", window.URL.createObjectURL(blob));
            element.setAttribute("download", 'claimfile.cws');
            element.style.display = "";
            element.click();
            close();
          }}
        >
          Download
        </MenuItem>
        <MenuItem
          onClick={()=>{
            const blob = new Blob([workshop.toHTML()],
                                  {type: 'text/html;charset=utf8;'});
            const element = document.createElement('a');
            element.setAttribute("href", window.URL.createObjectURL(blob));
            element.setAttribute("download", 'claimfile.html');
            element.style.display = "";
            element.click();
            close();
          }}
        >
          Export as HTML
        </MenuItem>
        <MenuItem
          onClick={()=>{
            const blob = new Blob([workshop.figsToHTML()],
                                  {type: 'text/html;charset=utf8;'});
            const element = document.createElement('a');
            element.setAttribute("href", window.URL.createObjectURL(blob));
            element.setAttribute("download", 'figures.html');
            element.style.display = "";
            element.click();
            close();
          }}
        >
          Export Figures
        </MenuItem>
        <MenuItem key='filemenu-new' onClick={newWithWarning} >
          New
        </MenuItem>
      </Menu>

      {/* --------------------------------------------------------------------*/}

      <Dialog
        style={{height: 450}}
        open={pickerVisible}
        onClose={() => close()}
        key='picker-dialog'
      >
        <DialogTitle>Select File</DialogTitle>
        <DialogContent>
          {path.slice(0).reverse().map((folder, idx) => folder.name + (idx === path.length-1 ? '' : ':'))}
          <List
            style={{height: 175, border: '1px solid black', overflow: 'auto'}}
          >
            {path.length === 1 ? null :
             <ListItem button dense key='picker-dir-up'
                       onClick={() => {
                         list(path[1].id);
                         setPath(path.slice(1));
                       }}>
               <ListItemIcon><ArrowUpward /></ListItemIcon>
               <ListItemText>(Up ...)</ListItemText>
             </ListItem>}
            {docs.map((item, idx) => {
              return (
                <ListItem button dense key={item.id} disabled={fetching}
                          onClick={() => {
                            if (item.mimeType === 'application/json') {
                              console.log('Setting:', item);
                              workshop.setDoc({name: item.name, id: item.id});
                            }
                            else {
                              setPath([item, ...path]);
                              list(item.id);
                            }}}
                >
                  <ListItemIcon>
                    {item.mimeType === 'application/json' ? <Description /> : <Folder />}
                  </ListItemIcon>
                  <ListItemText>{item.name}</ListItemText>
                </ListItem>);
            })}
          </List>
          <div style={{display: 'flex', margin: '0.5em', alignItems: 'baseline',
                       justifyContent: 'space-between'}}>
            <TextField
              key='picker-dialog-textfield'
              style={{width: '50%'}}
              label='File name' variant='outlined'
              value={workshop.doc.name}
              onBlur={() => {
                console.log('Blurring');
                if (!workshop.doc.name.endsWith('.cws'))
                  workshop.setDocName(workshop.doc.name + '.cws');
              }}
              onChange={(e) => {
                console.log('OC', e.target.value);
                let newVal = e.target.value;
                if (action.startsWith('save'))
                  workshop.setDocName(newVal);
              }}/>
            <span>
              <Button
                color="primary" 
                disabled={!workshop.doc.name || fetching}
                onClick={()=>{
                  close();
                  if (action === 'save') {
                    save();
                  }
                  else if (action === 'save as') {
                    // note this approach will silently create a new file possibly
                    // having the same name as an existing file
                    workshop.doc.id = null; // need to null this out to create new file
                    save();
                  }
                  else if (action === 'load') {
                    load();
                  }
                }}>
                {action}
              </Button>
              <Button color="secondary" 
                      onClick={() => close()}>
                Cancel
              </Button>
            </span>
          </div>
        </DialogContent>
      </Dialog> 

      {/* --------------------------------------------------------------------*/}

      <Dialog
        open={warningVisible}
        onClose={() => close()}
        key='warning-dialog'
      >
        <DialogTitle>Unsaved Changes!</DialogTitle>
        <DialogContent>
          Do you want to save your unsaved changes?
          <DialogActions>
            <Button
              color="primary" variant="outlined"
              onClick={() => {
                close();
                doSave();
              }}>
              Save
              </Button>
            <Button color="secondary" variant="outlined"
                    onClick={() => {
                      close();
                      if (action === 'new') workshop.newClaimSet();
                      if (action === 'load') openPicker('load');
                    }}>
              Discard
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog> 



    </span>);
});


// export const GDriveButton = observer((props) => {
//   const workshop = props.workshop;
//   const Component = props.component || Button;

//   return (
//     <div key={'gdbtn_' + props.type} >
//       <Component disabled={props.fetching}
//                  onClick={() => {
//                    if (workshop.doc && props.type === 'save') {
//                      props.close();
//                      props.save(workshop.doc);
//                    }
//                    else {
//                      list(path[0].id);
//                      setPickerVisible(true);
//                    }
//                  }}
//       >
//         {props.label}
//       </Component>
//       <Dialog
//         style={{height: 450}}
//         open={pickerVisible}
//         onClose={() => close()}
//         key='picker-dialog'
//       >
//         <DialogTitle>Select File</DialogTitle>
//         <DialogContent>
//           {path.slice(0).reverse().map((folder, idx) => folder.name + (idx === path.length-1 ? '' : ':'))}
//           <List
//             style={{height: 175, border: '1px solid black', overflow: 'auto'}}
//           >
//             {path.length === 1 ? null :
//              <ListItem button dense key='picker-dir-up'
//                        onClick={() => {
//                          list(path[1].id);
//                          setPath(path.slice(1));
//                        }}>
//                <ListItemIcon><ArrowUpward /></ListItemIcon>
//                <ListItemText>(Up ...)</ListItemText>
//              </ListItem>}
//             {docs.map((item, idx) => {
//               return (
//                 <ListItem button dense key={item.id} disabled={fetching}
//                           onClick={() => {
//                             if (item.mimeType === 'application/json') {
//                               setDocName(item.name);
//                               setDocID(item.id);
//                             }
//                             else {
//                               setPath([item, ...path]);
//                               list(item.id);
//                             }}}
//                 >
//                   <ListItemIcon>
//                     {item.mimeType === 'application/json' ? <Description /> : <Folder />}
//                   </ListItemIcon>
//                   <ListItemText>{item.name}</ListItemText>
//                 </ListItem>);
//             })}
//           </List>
//           <div style={{display: 'flex', margin: '0.5em', alignItems: 'baseline',
//                        justifyContent: 'space-between'}}>
//             <TextField
//               key='picker-dialog-textfield'
//               style={{width: '50%'}}
//               label='File name' variant='outlined'
//               value={docName || ''}
//               onBlur={() => {
//                 //console.log('Blurring');
//                 if (!docName.endsWith('.cws'))
//                   setDocName(docName + '.cws');
//               }}
//               onChange={(e)=> {
//                 //console.log('OC', e.target);
//                 let newVal = e.target.value;
//                 if (props.type.startsWith('save'))
//                   setDocName(newVal);
//               }}/>
//             <span>
//               <Button
//                 color="primary" variant="outlined"
//                 disabled={!docName || fetching}
//                 onClick={()=>{
//                   close();
//                   if (props.type.startsWith('save')) {
//                     save({name: docName, id: docID});
//                   }
//                   else if (props.type === 'load') {
//                     load();
//                   }
//                 }}>
//                 {props.label}
//               </Button>
//               <Button color="secondary" variant="outlined"
//                       onClick={() => close()}>
//                 Cancel
//               </Button>
//               {/*
//                  <IconButton disabled={path.length < 2 || fetching}
//                  onClick={() => {
//                  console.log('Going up', path);
//                  list(path[1].id);
//                  setPath(path.slice(1));
//                  }}>
//                  <ArrowUpward/></IconButton>*/}
//             </span>
//           </div>
//         </DialogContent>
//       </Dialog> 
//     </div>
    
//   );
// });


var picker = null;

// Create and render a Picker object for searching images.
export const createGooglePicker = () => {
  const create = () => {
    const google = window.google;
    const oauthToken = OAuthToken;
    console.log('Creating picker', pickerApiLoaded, oauthToken);
    if (pickerApiLoaded && oauthToken) {
      if (!picker) {
        //var view = new google.picker.View(google.picker.ViewId.DOCS);
        var view = new google.picker.DocsView().setIncludeFolders();
        //view.setMimeTypes("application/json");
        picker = new google.picker.PickerBuilder()
          .enableFeature(google.picker.Feature.NAV_HIDDEN)
          .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
          .setAppId(appId)
          .setOAuthToken(oauthToken)
          .addView(view)
          .setDeveloperKey(API_KEY)
          .setCallback((val) => console.log(val))
          .build();
      }
      picker.setVisible(true);
    }
  };
  authenticated(create);
}


/**

export default class GoogleChooser extends React.Component {

  static propTypes = {
    children: PropTypes.node,
    clientId: PropTypes.string.isRequired,
    developerKey: PropTypes.string,
    scope: PropTypes.array,
    viewId: PropTypes.string,
    authImmediate: PropTypes.bool,
    origin: PropTypes.string,
    onChange: PropTypes.func,
    onAuthenticate: PropTypes.func,
    onAuthFailed: PropTypes.func,
    createPicker: PropTypes.func,
    multiselect: PropTypes.bool,
    navHidden: PropTypes.bool,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    onChange: () => {},
    onAuthenticate: () => {},
    onAuthFailed: () => {},
    scope:['https://www.googleapis.com/auth/drive.readonly'],
    viewId: 'DOCS',
    authImmediate: false,
    multiselect: false,
    navHidden: false,
    disabled: false
  };

  componentDidMount() {
    if(isGoogleReady()) {
      // google api is already exists
      // init immediately
      //onApiLoad();
    } else if (!scriptLoadingStarted) {
      // load google api and the init
      console.log('Loading script');
      scriptLoadingStarted = true;
      loadScript(GOOGLE_SDK_URL, loadAPI)
    } else {
      // is loading
    }
  }



  onChoose = () => {
    authenticated(() => this.createPicker());
  }
  
  createPicker = () => {
    
    this.props.onAuthenticate(OAuthToken);
    
    if(this.props.createPicker){
      return this.props.createPicker(window.google, OAuthToken)
    }

    const googleViewId = window.google.picker.ViewId[this.props.viewId];
    const view = new window.google.picker.View(googleViewId);

    if (this.props.mimeTypes) {
      view.setMimeTypes(this.props.mimeTypes.join(','))
    }
    if (this.props.query) {
      view.setQuery(this.props.query)
    }

    if (!view) {
      throw new Error('Can\'t find view by viewId');
    }

    const picker = new window.google.picker.PickerBuilder()
          .addView(view)
          .setOAuthToken(OAuthToken)
          .setDeveloperKey(this.props.developerKey)
          .setCallback(this.props.onChange);

    if (this.props.origin) {
      picker.setOrigin(this.props.origin);
    }

    if (this.props.navHidden) {
      picker.enableFeature(window.google.picker.Feature.NAV_HIDDEN)
    }

    if (this.props.multiselect) {
      picker.enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
    }

    picker.build()
      .setVisible(true);
  };

  render() {
    return (
      <div onClick={this.onChoose}>
        {
          this.props.children ?
            this.props.children :
            <button>Open google chooser</button>
        }
      </div>
    );
  }
}

*/


// -----------------------------------------------------------------------------
/**


   var theDoc = null;

   // A simple callback implementation.
   function pickerCallback(data) {
   console.log('CAllbak', data);
   if (data.action == window.google.picker.Action.PICKED) {
   var fileId = data.docs[0].id;
   theDoc = data.docs[0];
   console.log('PICKED ', theDoc);
   }
   }

   export function save(dumpedClaimSet) {
   if (!theDoc) {
   loadPicker()
   return;
   }
   console.log('SAVING');
   var file = new Blob([JSON.stringify(dumpedClaimSet, null, 2)], {type: 'application/json'});
   var metadata = {
   'name': theDoc.name,   // Filename at Google Drive
   'id': theDoc.id,
   'mimeType': 'application/json', // mimeType at Google Drive
   'parents': [theDoc.parentId], // Folder ID at Google Drive
   };
   console.log(metadata);
   //var metadata = theDoc;
   
   var accessToken = oauthToken; //gapi.auth.getToken().access_token; // Here gapi is used for retrieving the access token.
   var form = new FormData();
   form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
   form.append('file', file);
   
   fetch(`https://www.googleapis.com/upload/drive/v3/files/${theDoc.id}`, { //files?uploadType=multipart POST
   method: 'PATCH',
   headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
   body: form,
   }).then((res) => {
   console.log('RESULT', res)
   return res.json();
   }).then(function(val) {
   console.log('FETCH', val);
   }).catch(function(err) {
   console.log('ERROR', err);
   });
   }

**/
